import React from 'react';
import { TableRow, TableCell } from '@mui/material';
import SalesStaticTableCell from './SalesStaticTableCell';

const SalesStaticsEmpRows = ({ headerRows, data }) => {
  if (!headerRows || !data) {
    return null;
  }
  return (
    data &&
    data.map((hq, hqIndex) => {
      return (
        Array.isArray(hq?.children) &&
        hq?.children?.map((dp, dpIndex) => {
          return dp?.children?.map((emp, empIndex) => {
            let cellSpan = 1;
            if (emp.id === 'subTotal') {
              cellSpan = 2;
            } else if (emp.id === 'total') {
              cellSpan = 3;
            }

            return (
              <TableRow key={empIndex}>
                {dpIndex === 0 &&
                  empIndex === 0 &&
                  emp.id !== 'subTotal' &&
                  emp.id !== 'total' && (
                    <TableCell rowSpan={hq.rowSpan} sx={{ width: '130px' }}>
                      {hq.name}
                    </TableCell>
                  )}
                {empIndex === 0 &&
                  emp.id !== 'subTotal' &&
                  emp.id !== 'total' && (
                    <TableCell rowSpan={dp.rowSpan} sx={{ width: '130px' }}>
                      {dp.name}
                    </TableCell>
                  )}
                <TableCell
                  sx={{ width: '130px' }}
                  align={emp.id === 'subTotal' ? 'right' : 'left'}
                  colSpan={cellSpan}
                >
                  {emp.name}
                </TableCell>
                <SalesStaticTableCell headerRows={headerRows} data={emp} />
              </TableRow>
            );
          });
        })
      );
    })
  );
};

export default SalesStaticsEmpRows;
